import React from 'react';
import * as Scroll from 'react-scroll';
import { animateScroll as scroll } from 'react-scroll';
import { Link } from 'react-router-dom';
import { heights, spacing, colors, widths, fonts } from './../../styles/theme.json';
import SocialIcons from './../SocialIcons';

const scrollToTop = () => {
  scroll.scrollToTop({
    duration: 350
  });
};

const DesktopFooter = (props) => (
  <div className={'inner-footer'}>
    <div className={'footer-column footer-left'}>
      <div className={'copyright external-link'} dangerouslySetInnerHTML={{__html:'&#169; Bruce Weber'}}/>
      <Link className={'terms external-link'} to={'/terms'}>Terms</Link>
    </div>
    <div className={'footer-column footer-center'}>
      <SocialIcons/>
    </div>
    <div className={'footer-column footer-right'}>
      <Link className={'contact external-link'} to={'/contact'}>Contact</Link>
      <div className={'top external-link btt'} onClick={scrollToTop}>Back to Top</div>
    </div>
    <style jsx>{`
      .btt {
        cursor: pointer;
      }
      .inner-footer {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.5rem 0;
      }
      .footer-column {
        display: flex;
        flex-direction: row;
      }
      .footer-left,
      .footer-right {
        width: 24rem;
        display: flex;
      }
      .footer-right {
        justify-content: flex-end;
      }
      .copyright {
        font-size: ${fonts.footer_size};
        font-family: ${fonts.mallory};
        font-weight: 700;
        text-transform: uppercase;
        font-size: 1.2rem;
        border: 0;
      }
      .top,
      .terms {
        margin-left: 3rem;
        color: ${colors.black};
        display: block;
      }
      .top,
      .contact {
        color: ${colors.black};
        border-bottom: 1px solid ${colors.black};
      }
    `}</style>
  </div>
);

export default DesktopFooter;



// WEBPACK FOOTER //
// ./src/components/footer/DesktopFooter.js